var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 42.3002C23.4 42.3002 22.8 42.0799 22.35 41.7127C20.625 40.2439 18.9 38.8486 17.4 37.6002C13.05 34.0018 9.225 30.8439 6.6 27.7596C3.6 24.2346 2.25 21.0033 2.25 17.4049C2.25 13.9533 3.45 10.7221 5.7 8.37207C7.95 6.02207 11.025 4.7002 14.4 4.7002C16.875 4.7002 19.2 5.50801 21.225 6.97676C22.05 7.56426 22.725 8.29863 23.4 9.10644C23.7 9.47363 24.225 9.47363 24.525 9.10644C25.2 8.29863 25.95 7.63769 26.7 6.97676C28.725 5.43457 31.05 4.7002 33.525 4.7002C36.9 4.7002 39.975 6.02207 42.225 8.37207C44.475 10.7221 45.675 13.9533 45.675 17.4049C45.675 21.0033 44.325 24.2346 41.325 27.6861C38.7 30.7705 34.875 33.9283 30.525 37.5268C29.025 38.7752 27.3 40.1705 25.575 41.6393C25.2 42.0799 24.6 42.3002 24 42.3002Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFilled);
export default __webpack_public_path__ + "static/media/heart-filled.240ee30a198bf8921eb5edebfa574867.svg";
export { ForwardRef as ReactComponent };